import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, TitleHeader } from 'web-library';
import AppealReceipt from '../../modules/appeal/components/@candidate/AppealReceipt';

const Receipt = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader
        state="success"
        title={t('appeal->>AppealReceipt.SubmittedAppeal')}
        largeContentContainer
      />

      <ContentTemplate>
        <AppealReceipt />
      </ContentTemplate>
    </>
  );
};

export default Receipt;
